import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updateUserRegistration.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updateUserRegistration.error;
export const updateUserRegistrationSettingResponse = (state: RootState) =>
  state.updateUserRegistration.updateUserRegistrationSettingResponse;
